import React from 'react'
import { Box, Flex } from '@workwhile/ui'
import { RelatedPayment } from 'api/payments/getUserPayments'
import { BundledPaymentsAmountTable } from './BundledPaymentsAmountTable'
import { PaymentWorkSummary } from './PaymentWorkSummary'

type RelatedPaymentsTooltipContentProps = {
  relatedPayments: RelatedPayment[]
  payoutAmount?: number
  highlightPaymentId?: number
  payoutStatus?: RelatedPayment['status']
}

export const RelatedPaymentsTooltipContent = ({
  relatedPayments,
  payoutAmount,
  highlightPaymentId,
  payoutStatus,
}: RelatedPaymentsTooltipContentProps) => {
  if (payoutAmount != null) {
    return (
      <BundledPaymentsAmountTable
        relatedPayments={relatedPayments}
        payoutAmount={payoutAmount}
        highlightPaymentId={highlightPaymentId}
        payoutStatus={payoutStatus}
      />
    )
  }

  return (
    <Flex flexDirection="column" gap={2}>
      {relatedPayments.map((payment, index) => (
        <Box
          key={payment.id}
          pt={index > 0 ? 2 : 0}
          borderTop={index > 0 ? '1px solid' : undefined}
          borderColor={index > 0 ? 'neutrals.100' : undefined}
        >
          <PaymentWorkSummary {...payment} />
        </Box>
      ))}
    </Flex>
  )
}
